module.exports = "img/cancel-black2.c44b7c1.png";